module.exports = __webpack_public_path__ + "img/cat-2.7b297fe3.png";